// extracted by mini-css-extract-plugin
module.exports = {"calendar":"UFOPeriodDateFieldDialog_calendar__3vvC5","visible":"UFOPeriodDateFieldDialog_visible__2IgBN","calendarTable":"UFOPeriodDateFieldDialog_calendarTable__21SDV"};